// Captured 5/21/2020
// https://zeroheight.com/2b9d6d810/p/684428-design-tokens/t/594161
export var designTokens = {
  colors: {
    aqua050: '#f6fafc',
    aqua100: '#d7e8ed',
    aqua200: '#bad5dd',
    aqua300: '#9ec1ca',
    aqua400: '#85acb6',
    aqua500: '#6d95a0',
    aqua600: '#547b86',
    aqua700: '#3d606a',
    aqua800: '#28444b',
    aqua900: '#15272b',
    black: '#000000',
    blue050: '#f2f8ff',
    blue100: '#c2dcff',
    blue200: '#91bff7',
    blue300: '#61a3e9',
    blue400: '#3186d5',
    blue500: '#1269ba',
    blue600: '#0156a4',
    blue700: '#004288',
    blue800: '#002e66',
    blue900: '#001a3d',
    blueGray050: '#fafbfc',
    blueGray100: '#e8edf2',
    blueGray200: '#d7dfe6',
    blueGray300: '#c7d1da',
    blueGray400: '#b8c2cd',
    blueGray500: '#a9b4bf',
    blueGray600: '#87929d',
    blueGray700: '#667079',
    blueGray800: '#464d55',
    blueGray900: '#262b30',
    burgundy050: '#fdf2f3',
    burgundy100: '#f2c2c9',
    burgundy200: '#e391a0',
    burgundy300: '#cf617b',
    burgundy400: '#b63b58',
    burgundy500: '#981a37',
    burgundy600: '#850b27',
    burgundy700: '#6e011a',
    burgundy800: '#52000f',
    burgundy900: '#310007',
    coolGray050: '#f6f7f8',
    coolGray100: '#d6d9db',
    coolGray200: '#b5babe',
    coolGray300: '#959ba0',
    coolGray400: '#767d82',
    coolGray500: '#575e63',
    coolGray600: '#464c51',
    coolGray700: '#353b3f',
    coolGray800: '#24292c',
    coolGray900: '#141719',
    darkContextHigh: 'rgba(255, 255, 255, 0.24)',
    darkContextLow: 'rgba(255, 255, 255, 0.04)',
    darkContextMedium: 'rgba(255, 255, 255, 0.12)',
    darkEmphasisHigh: '#ffffff',
    darkEmphasisLow: 'rgba(255, 255, 255, 0.6)',
    darkEmphasisMedium: 'rgba(255, 255, 255, 0.8)',
    darkError: '#d66d6d',
    darkGreen050: '#f6fbf6',
    darkGreen100: '#d3e8d3',
    darkGreen200: '#b2d4b2',
    darkGreen300: '#93be93',
    darkGreen400: '#76a675',
    darkGreen500: '#5b8c5a',
    darkGreen600: '#467645',
    darkGreen700: '#335d32',
    darkGreen800: '#214320',
    darkGreen900: '#112611',
    darkLink: '#61a3e9',
    darkMainContainer: '#13202d',
    darkOk: '#accb85',
    darkPageBackground: '#0a121a',
    darkRed050: '#FEF2F2',
    darkRed100: '#F5C2C2',
    darkRed200: '#E89595',
    darkRed300: '#D66D6D',
    darkRed400: '#C04A4A',
    darkRed500: '#A52C2C',
    darkRed600: '#901A1A',
    darkRed700: '#750C0C',
    darkRed800: '#570303',
    darkRed900: '#330000',
    darkWarning: '#ff9467',
    gray050: '#f6f6f6',
    gray100: '#d4d4d5',
    gray200: '#b2b2b3',
    gray300: '#919191',
    gray400: '#6f6f70',
    gray500: '#4d4d4e',
    gray600: '#3e3e3f',
    gray700: '#303031',
    gray800: '#212122',
    gray900: '#121213',
    green050: '#f8fcf4',
    green100: '#dfefcc',
    green200: '#c6dea7',
    green300: '#accb85',
    green400: '#92b566',
    green500: '#779b4a',
    green600: '#618435',
    green700: '#4b6a24',
    green800: '#344d15',
    green900: '#1d2d0a',
    lightContextHigh: 'rgba(0, 0, 0, 0.12)',
    lightContextLow: 'rgba(0, 0, 0, 0.02)',
    lightContextMedium: 'rgba(0, 0, 0, 0.08)',
    lightEmphasisHigh: 'rgba(0, 0, 0, 0.9)',
    lightEmphasisLow: 'rgba(0, 0, 0, 0.4)',
    lightEmphasisMedium: 'rgba(0, 0, 0, 0.6)',
    lightError: '#a52c2c',
    lightLink: '#1269ba',
    lightMainContainer: '#ffffff',
    lightOk: '#618435',
    lightPageBackground: '#f6f7f8',
    lightWarning: '#cf4a19',
    navy050: '#f4f6f8',
    navy100: '#ccd4dc',
    navy200: '#a5b2be',
    navy300: '#7f909f',
    navy400: '#5b6d7f',
    navy500: '#384b5d',
    navy600: '#2a3d4e',
    navy700: '#1e2f3e',
    navy800: '#13202d',
    navy900: '#0a121a',
    orange050: '#fff5f2',
    orange100: '#ffd1c2',
    orange200: '#ffb091',
    orange300: '#ff9467',
    orange400: '#ff7b49',
    orange500: '#ff6633',
    orange600: '#cf4a19',
    orange700: '#9e3306',
    orange800: '#6e1f00',
    orange900: '#3d0f00',
    purple050: '#fbf3f8',
    purple100: '#ebc5dd',
    purple200: '#d89cc2',
    purple300: '#c175a5',
    purple400: '#a75287',
    purple500: '#893269',
    purple600: '#762257',
    purple700: '#601444',
    purple800: '#460a30',
    purple900: '#29041b',
    red050: '#fef5f6',
    red100: '#f9cfd3',
    red200: '#f0aeb4',
    red300: '#e49098',
    red400: '#d4767e',
    red500: '#c05f68',
    red600: '#a3454e',
    red700: '#832f37',
    red800: '#5f1c23',
    red900: '#370e11',
    teal050: '#f6fefc',
    teal100: '#d4f9ee',
    teal200: '#b5f1df',
    teal300: '#9ae6cf',
    teal400: '#83d7be',
    teal500: '#6ec5ab',
    teal600: '#52a78d',
    teal700: '#39856e',
    teal800: '#24604e',
    teal900: '#12382c',
    white: '#ffffff',
    yellow050: '#fffff2',
    yellow100: '#ffffc5',
    yellow200: '#ffff9e',
    yellow300: '#fffb7e',
    yellow400: '#fff164',
    yellow500: '#ffe251',
    yellow600: '#cfc134',
    yellow700: '#9e9b1d',
    yellow800: '#6e6e0c',
    yellow900: '#3d3d03'
  },
  fonts: {
    buttonAction: {
      fontSize: '14px',
      color: 'rgba(0,0,0,0.90)',
      letterSpacing: '1px',
      lineHeight: '20px',
      fontFamily: 'Muli SemiBold',
      fontWeight: 600,
      textTransform: 'uppercase',
      textAlign: 'left',
      paragraphSpacing: 0
    },
    body1: {
      fontSize: '16px',
      color: 'rgba(0,0,0,0.90)',
      fontFamily: 'Muli',
      fontWeight: 400,
      textAlign: 'left',
      paragraphSpacing: 0
    },
    body2: {
      fontSize: '14px',
      color: 'rgba(0,0,0,0.90)',
      letterSpacing: '0.15px',
      lineHeight: '20px',
      fontFamily: 'Muli',
      fontWeight: 400,
      textAlign: 'left',
      paragraphSpacing: 0
    },
    caption: {
      fontSize: '12px',
      color: 'rgba(0,0,0,0.90)',
      letterSpacing: '0.2px',
      lineHeight: '16px',
      fontFamily: 'Muli',
      fontWeight: 400,
      textAlign: 'left',
      paragraphSpacing: 0
    },
    code: {
      fontSize: '15px',
      color: 'rgba(0,0,0,0.90)',
      fontFamily: 'Source Code Pro',
      fontWeight: 400,
      textAlign: 'left',
      paragraphSpacing: 0
    },
    h1: {
      fontSize: '101px',
      color: 'rgba(0,0,0,0.90)',
      letterSpacing: '-1.5px',
      fontFamily: 'Muli Light',
      fontWeight: 300,
      textAlign: 'left',
      paragraphSpacing: 0
    },
    h2: {
      fontSize: '64px',
      color: 'rgba(0,0,0,0.90)',
      letterSpacing: '-0.5px',
      fontFamily: 'Muli Light',
      fontWeight: 300,
      textAlign: 'left',
      paragraphSpacing: 0
    },
    h3: {
      fontSize: '50px',
      color: 'rgba(0,0,0,0.90)',
      fontFamily: 'Muli',
      fontWeight: 400,
      textAlign: 'left',
      paragraphSpacing: 0
    },
    h4: {
      fontSize: '36px',
      color: 'rgba(0,0,0,0.90)',
      letterSpacing: '0.25px',
      fontFamily: 'Muli',
      fontWeight: 400,
      textAlign: 'left',
      paragraphSpacing: 0
    },
    h5: {
      fontSize: '24px',
      color: 'rgba(0,0,0,0.90)',
      lineHeight: '32px',
      fontFamily: 'Muli',
      fontWeight: 400,
      textAlign: 'left',
      paragraphSpacing: 0
    },
    h6: {
      fontSize: '21px',
      color: 'rgba(0,0,0,0.90)',
      letterSpacing: '0.16px',
      fontFamily: 'Muli SemiBold',
      fontWeight: 600,
      textAlign: 'left',
      paragraphSpacing: 0
    },
    overline1: {
      fontSize: '12px',
      color: 'rgba(0,0,0,0.90)',
      letterSpacing: '1.5px',
      fontFamily: 'Muli',
      fontWeight: 400,
      textTransform: 'uppercase',
      textAlign: 'left',
      paragraphSpacing: 0
    },
    overline2: {
      fontSize: '13px',
      color: 'rgba(0,0,0,0.90)',
      letterSpacing: '1.1px',
      fontFamily: 'Muli',
      fontWeight: 700,
      textTransform: 'uppercase',
      textAlign: 'left',
      paragraphSpacing: 0
    },
    subtitle1: {
      fontSize: '17px',
      color: 'rgba(0,0,0,0.90)',
      letterSpacing: '0.15px',
      fontFamily: 'Muli',
      fontWeight: 400,
      textAlign: 'left',
      paragraphSpacing: 0
    },
    subtitle2: {
      fontSize: '15px',
      color: 'rgba(0,0,0,0.90)',
      letterSpacing: '0.15px',
      fontFamily: 'Muli SemiBold',
      fontWeight: 600,
      textAlign: 'left',
      paragraphSpacing: 0
    },
    surtitle: {
      fontSize: '12px',
      color: 'rgba(0,0,0,0.54)',
      letterSpacing: '1.5px',
      fontFamily: 'Muli',
      fontWeight: 400,
      lineHeight: 'inherit',
      textTransform: 'uppercase',
      textAlign: 'left',
      paragraphSpacing: 0
    }
  }
};
//# sourceMappingURL=Theme.design-tokens.js.map